import { createTheme } from '@mui/material';

export default createTheme({
  typography: {
    fontFamily: 'Lato, sans-serif',
  },
});
